/**
 * One hour's tags in the hour card: each tested tag with its verdict — the
 * tag's colour when the hour carries it, muted when not, dashed with the
 * reason when the tag cannot judge the hour.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import { hourTagWhy, type HourTagVerdict } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { TagDot } from '../../../rules/tags';

interface Props {
  tags: Record<string, HourTagVerdict>;
  colors?: Record<string, string>;
}

const Chip: FC<{ name: string; v: HourTagVerdict; color?: string }> = ({ name, v, color }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs',
      v.state === 'tagged' ? 'border-border font-medium text-foreground' : 'border-dashed border-border/70 text-muted-foreground',
    )}
    data-state={v.state}
  >
    <TagDot color={color} unknown={v.state === 'unknown'} />
    {name}
    <span className="text-[11px] text-muted-foreground">
      {v.state === 'tagged' ? '' : v.state === 'not_tagged' ? '· not tagged' : `· unknown — ${hourTagWhy(v)}`}
    </span>
  </span>
);

export const HourTagChips: FC<Props> = ({ tags, colors }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="hour-tag-chips">
    {Object.entries(tags).map(([name, v]) => (
      <Chip key={name} name={name} v={v} color={colors?.[name]} />
    ))}
  </div>
);
